module.exports = __webpack_public_path__ + "img/neymar-jr.8040c522.png";